
const Vr18 = () => {

    return (
      <div style={{ width: "100%", height: "100vh" }}>
        <iframe
          src={`https://hitimperial.github.io/VR360-18/PNG%20n.3/3d%2018-3/publish%2018-3/index.htm`}
          width="100%"
          height="100%"
          style={{ border: "none" }}
          allowFullScreen
          title="VR 18 Tour"
        ></iframe>
      </div>
    );
};

export default Vr18;
